
export const requerido = (errores, campo, state1, state2, tituloState2, errName, respuesta) => {
    let states = []
    let errorName = ""
    if (campo === null) {
        states.push({
            [state1]:{ text: "", status: "has-error" },
            [state2]:{ text: "Datos Incompletos", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }else{
        if (campo.length === 0) {
            states.push({
                [state1]:{ text: "", status: "has-error" },
                [state2]:{ text: "Datos Incompletos", status: "text-danger" }
            });
            errores ++;
            errorName = errName;
        }else{
            states.push({
                [state1]:{ text: campo, status: "" },
                [state2]:{ text: tituloState2, status: "" }
            });
        }
    }
    
    respuesta ([states, errores, errorName])
}

export const numero = (errores, campo, state1, state2, errName, respuesta) => {
    let states = []
    let errorName = ""

    if (!isNaN(Number(campo)) === false){
        states.push({
            [state1]:{ text: "", status: "has-error" },
            [state2]:{ text: "Formato Incorrecto", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }

    respuesta ([states, errores, errorName])
}

export const letras = (errores, campo, state1, state2, errName, respuesta) => {
    let states = [];
    let errorName = "";
    let expresion = /^[A-Z]+$/i;

    if (expresion.test(campo)=== false){
        states.push({
            [state1]:{ text: "", status: "has-error" },
            [state2]:{ text: "Formato Incorrecto", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }

    respuesta ([states, errores, errorName])
}

export const selectRequerido = (errores, campo, state1, label, errName, respuesta) => {
    let states = []
    let errorName = ""
    if (campo === null) {
        states.push({
            [state1]:{
                value: "", label: label, status: {
                    singleValue: () => ({ color: '#FF4A55' }),
                }
            },
        });
        errores ++;
        errorName = errName;
    }else{
        if (campo.value.length === 0) {
            states.push({
                [state1]:{
                    value: "", label: label, status: {
                        singleValue: () => ({ color: '#FF4A55' }),
                    }
                },
            });
            errores ++;
            errorName = errName;
        }else{
            states.push({
                [state1]:{ value: campo.value, label: campo.label, status: "" },
            });
        }
    }

    respuesta ([states, errores, errorName])
}

export const requeridoFecha = (errores, campo, errName, respuesta) => {
    let states = []
    let errorName = ""

    if (campo === null) {
        states.push({
            fechaStatus: "has-error" ,
            fechaTit:{ text: "Datos Incompletos", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }else{
        states.push({
            fechaStatus: "" ,
            fechaTit:{ text: "* Fecha de Nacimiento", status: "" }
        });
    }

    respuesta ([states, errores, errorName])
}

export const limpiaCamposRepre = (respuesta) => {
    let states = []

    states.push({
        cedulaRepre:{ text: "", status: "" },
        cedRepre:{ text: "Cédula de Identidad", status: "" },
        nombre1Repre:{ text: "", status: "" },
        nombresRepre:{ text: "Nombres", status: "" },
        apellido1Repre:{ text: "", status: "" },
        apellidosRepre:{ text: "Apellidos", status: "" },

        selectPaisRepre: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        selectEstadoRepre: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        selectCiudadRepre: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        selectMunicipioRepre: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        selectParroquiaRepre: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },

        emailRepre: { text: "", status: "" },
        telefonosRepre: { text: "Teléfonos", status: "" },
        tlf1Repre: { text: "", status: "" },
        tlf2Repre: { text: "", status: "" },
        tlf3Repre: { text: "", status: "" },
    });

    respuesta ([states])
}

export const email = (errores, campo, state1, state2, tituloState2, errName, respuesta) => {
    let states = []
    let errorName = ""
    let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

    if (expReg.test(campo) === false) {
        states.push({
            [state1]:{ text: "", status: "has-error" },
            [state2]:{ text: "Formato Incorrecto", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }else{
        states.push({
            [state1]:{ text: campo, status: "" },
            [state2]:{ text: tituloState2, status: "" }
        });
    }

    respuesta ([states, errores, errorName])
}

export const conHora = (hora, min) => {
    return new Date('','','',hora, parseInt(min - 1), 0)
}

export const NuevasHoras = ([
    conHora(7, 15),
    conHora(8, 15),
    conHora(9, 15),
    conHora(10, 15),
    conHora(11, 15),
    conHora(12, 15),
    conHora(13, 15),
    conHora(14, 15),
    conHora(15, 15),
    conHora(16, 15),
    conHora(17, 15),
    conHora(18, 15),
    conHora(19, 15),
    conHora(20, 15),

    conHora(7, 45),
    conHora(8, 45),
    conHora(9, 45),
    conHora(10, 45),
    conHora(11, 45),
    conHora(12, 45),
    conHora(13, 45),
    conHora(14, 45),
    conHora(15, 45),
    conHora(16, 45),
    conHora(17, 45),
    conHora(18, 45),
    conHora(19, 45),
    conHora(20, 45),
])


export const requeridoFile = (errores, campo, state1, state2, tituloState2, errName, respuesta) => {
    let states = []
    let errorName = ""
    if (campo === "") {
        states.push({
            [state1]:{ text: "", status: "has-error" },
            [state2]:{ text: "Datos Incompletos", status: "text-danger" }
        });
        errores ++;
        errorName = errName;
    }else{
        states.push({
            [state1]:{ text: campo, status: "" },
            [state2]:{ text: tituloState2, status: "" }
        });
    }
    
    respuesta ([states, errores, errorName])
}


// WEBPACK FOOTER //
// ./src/funciones/Validaciones.jsx